export const PW_MAX = 32;
export const PW_MIN = 8;
export const PW_MATCHES = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{0,}$/g;